<div mat-dialog-title>
    <div class="grid justify-center">
      <ng-container *ngIf="data.action == 'edit'">Update Profile</ng-container>      
    </div>
  </div>
  
  <mat-dialog-content>
    <form class="flex-1" [formGroup]="profileFrom">
        <div class="flex flex-col sm:flex-row gap-3">
          <div class="flex-1 flex flex-col sm:flex-row gap-2">
            <div class="control-box flex-1 mt-1">
              <mat-form-field appearance="outline">
                <mat-label>User Name*</mat-label>
                <input matInput formControlName="user_name">
                <mat-error
                  *ngIf="profileFrom.get('user_name').touched && profileFrom.get('user_name').errors?.required">
                  Enter User name</mat-error>
                <mat-error *ngIf="profileFrom.get('user_name').errors?.serverType">
                  {{profileFrom.get('user_name').errors?.serverType.message}}
                </mat-error>
              </mat-form-field>
            </div>
          
            <div class="control-box flex-1 mt-1">
              <mat-form-field appearance="outline">
                <mat-label>Email Id*</mat-label>
                <input matInput formControlName="email">
                <mat-error
                  *ngIf="profileFrom.get('email').touched && profileFrom.get('email').errors?.required">
                  Enter Email Id</mat-error>
                <mat-error *ngIf="profileFrom.get('email').errors?.serverType">
                  {{profileFrom.get('email').errors?.serverType.message}}
                </mat-error>
              </mat-form-field>
    
            </div>
            <div class="control-box flex-1 mt-1">
                <mat-form-field appearance="outline">
                  <mat-label>Mobile Number*</mat-label>
                  <input matInput formControlName="mobile_number">
                  <mat-error
                    *ngIf="profileFrom.get('mobile_number').touched && profileFrom.get('mobile_number').errors?.required">
                    Enter Mobile Number</mat-error>
                  <mat-error *ngIf="profileFrom.get('mobile_number').errors?.serverType">
                    {{profileFrom.get('mobile_number').errors?.serverType.message}}
                  </mat-error>
                </mat-form-field>
      
              </div>
          </div>
        </div>
    
        <!-- Password -->
    
        <div class="flex flex-col sm:flex-row gap-3">
          <div class="flex flex-1 flex-col sm:flex-row gap-2">
            <div class="control-box flex-1">
              <mat-form-field appearance="outline">
                <mat-label>Enter Password *</mat-label>
                <input formControlName="password" matInput [type]="passwordVisible ? 'password' : 'text'">
                <button mat-icon-button matSuffix (click)="passwordVisible=!passwordVisible" [attr.aria-label]="'passwordVisible password'" [attr.aria-pressed]="passwordVisible">
          <mat-icon>{{passwordVisible ? 'visibility_off' :'visibility'}}</mat-icon>
        </button>
                <mat-error
                  *ngIf="profileFrom.get('password').touched && profileFrom.get('password').errors?.required">
                  Enter Password</mat-error>
                <mat-error *ngIf="profileFrom.get('password').errors?.serverType">
                  {{profileFrom.get('password').errors?.serverType.message}}
                </mat-error>
              </mat-form-field>
            </div>
            <div class="control-box flex-1">
              <mat-form-field appearance="outline">
                <mat-label>Confirm Password *</mat-label>
                <input formControlName="confirmPassword" matInput [type]="confirmpasswordVisible ? 'password' : 'text'">
                <button mat-icon-button matSuffix (click)="confirmpasswordVisible=!confirmpasswordVisible" [attr.aria-label]="'confirmpasswordVisible password'" [attr.aria-pressed]="confirmpasswordVisible">
          <mat-icon>{{confirmpasswordVisible ? 'visibility_off' :'visibility'}}</mat-icon>
        </button>
                <mat-error
                  *ngIf="profileFrom.get('confirmPassword').touched && profileFrom.get('confirmPassword').errors?.required">
                  Enter confirmPassword</mat-error>               
                <mat-error *ngIf="profileFrom.get('confirmPassword').errors?.confirmPasswordValidator">
                    Confirm Password didn't match.
                </mat-error>
              </mat-form-field>
            </div>
    
          </div>
        </div>
    </form>
  </mat-dialog-content>
  
  <div class="flex flex-col sm:flex-row justify-content-end gap-3 p-2">
    <button [disabled]="profileFrom.invalid" (click)="Save()"
      mat-raised-button color="primary"><span *ngIf="!isLoading">
        save
      </span>
      <div *ngIf="isLoading" style="padding: 8px;">
        <mat-spinner style="margin: auto;" [diameter]="20"></mat-spinner>
      </div></button>
  
    <button mat-raised-button color="warn" (click)="close()">close</button>
  
  </div>